<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add store</span>
  </a>
</ng-template>
<smart-table [headers]="headers"
             [source]="source"
             [collapseAuto]="false"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [collapseByClick]="false"
             (collapsedChange)="initForm($event)"
             [navigate]="entityPath">
  <ng-template smartTableColumn="name" let-item>
    <td>
      <entity-link type="store"
                   [item]="item"
                   [strong]="true"
                   [info]="'key: ' + item.key"
                   [relativePath]="relativePath"
                   [isEntity]="isEntity">
      </entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="description" let-item>
    <td>
      <small class="text-muted">{{ item.description }}</small>
    </td>
  </ng-template>


  <ng-template smartTableColumn="storeGroup" let-item>
    <td>
      <entity-link type="storeGroup" [item]="item.storeGroup"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="product" let-item>
    <td>
      <entity-link type="product" [item]="item.product" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="updatedAt" let-item>
    <td>
      {{ item.updatedAt | moment }}
    </td>
  </ng-template>

<!--  <ng-template smartTableColumn="actions" let-item>-->
<!--    <td class="text-right text-nowrap">-->
<!--      <button class="btn btn-danger btn-square btn-icon" (click)="delete(item.id, 'store', item.name)">-->
<!--        <icon-trash></icon-trash>-->
<!--      </button>-->
<!--    </td>-->
<!--  </ng-template>-->

  <ng-template smartTableCollapse let-item let-index="index" let-collapse="collapse">
    <form [formGroup]="forms[item.id]" (ngSubmit)="save(item, index)">
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>Name</label>
            <form-group-simple name="name" placeholder="Name" formControlName="name"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>Description</label>
            <form-group-simple type="textarea" name="description" placeholder="Tell me about your awesome app" formControlName="description"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>Key</label>
            <form-group-simple name="key" placeholder="Key" formControlName="key"></form-group-simple>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('storeKey')">
          <div class="form-group">
            <label>App keys</label>
            <form-group-select entity="storeKey"
                               bindLabel="name"
                               bindValue="id"
                               [searchable]="true"
                               [storeQuery]="null"
                               placeholder="App key"
                               formControlName="storeKey">
            </form-group-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>Apple package name</label>
            <form-group-simple name="applePackageName" placeholder="name" formControlName="applePackageName"></form-group-simple>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Google package name</label>
            <form-group-simple name="googlePackageName" placeholder="Name" formControlName="googlePackageName"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
<!--          <btn-delete form actions type="action"-->
<!--                      [name]="item.name"-->
<!--                      (delete)="delete($event, item.id); collapse.hide()">-->
<!--          </btn-delete>-->
        </div>
        <div class="col-auto ml-auto">
          <div class="m-n2">
            <button class="btn btn-success m-2" type="submit" [disabled]="forms[item.id].disabled">
              Save
            </button>
            <button class="btn btn-outline-info m-2" type="button"
                    (click)="cancel(collapse)">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

